// extracted by mini-css-extract-plugin
export default {"draggable":"DraggableHTML--draggable--HPgS1"};